import React from 'react';

/**
 * @description Tarjeta de error reutilizable con ícono ⚠. Reemplaza los `<p>`
 * en rojo plano (mismo hex `#c0392b` suelto, sin caja ni ícono) que cada
 * página de listado escribía a mano para el error de carga inicial
 * (`loadError`) — hallazgo de auditoría "Claude Design" #08. Basada en el
 * `errorBox`/`errorIcon` que ya usaba Dashboard.js.
 *
 * Nota: esto NO reemplaza al banner `actionErrorBanner` (aviso dismisseable
 * que aparece sobre la tabla cuando falla un guardado/borrado) de cada
 * página — ese ya está resuelto y sigue viviendo en cada archivo tal cual.
 *
 * @param {string} message Mensaje de error a mostrar (ya viene traducido/formateado por la página).
 * @returns {JSX.Element}
 */
const ErrorState = ({ message }) => (
  <div style={styles.errorBox}>
    <span style={styles.errorIcon}>⚠</span> {message}
  </div>
);

const styles = {
  errorBox: {
    backgroundColor: '#fef2f2',
    border: '1px solid #fca5a5',
    borderRadius: '8px',
    padding: '16px 20px',
    color: '#b91c1c',
    fontSize: '14px',
  },
  errorIcon: {
    marginRight: '8px',
  },
};

export default ErrorState;
